import type { OrgMemberRow } from './org-members';

// Account → Members' roster export, built client-side — no server round-trip.
//
// Two escapes per cell. CSV STRUCTURE: every cell quoted, inner quotes doubled.
// FORMULA INJECTION (OWASP "CSV injection"): a spreadsheet executes a cell that
// leads with `=`, `+`, `-`, `@`, tab or CR — and an email's local part may
// legally start with `=`, `+` or `-`, so a member controls one. Such a cell gets
// a leading `'`, which spreadsheets read as "text". The deliberate OWASP
// trade-off: some spreadsheet apps show the `'` as data, and it survives re-import.

const FORMULA_LEAD = /^[=+\-@\t\r]/;

function cell(v: string): string {
  const safe = FORMULA_LEAD.test(v) ? `'${v}` : v;
  return `"${safe.replace(/"/g, '""')}"`;
}

/** The roster as CSV text: a header row, then one row per member, CRLF-joined. */
export function membersCsv(rows: readonly OrgMemberRow[]): string {
  const header = ['login', 'email', 'role', 'joined'];
  const lines = rows.map((m) => [m.login, m.email ?? '', m.role, m.joined_iso].map(cell).join(','));
  return [header.join(','), ...lines].join('\r\n');
}
